import React from "react";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import "./Image.scss";
import { getFileInfo } from "../../../utils/helper";
import commonImages from "../../../assets";

const File = ({
  files,
  handleCloseFile,
  imageUrl = "",
  deleteImageURL,
  isLoader,
  removeIcon = true,
}) => {
  const imageUrlConvertArray = Array.isArray(imageUrl)
    ? imageUrl
    : typeof imageUrl === "string" && imageUrl.length > 0
    ? imageUrl.split("|")
    : [];

  const uniqueImageUrls = [...new Set(imageUrlConvertArray)];

  const handleDownload = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="overideImage">
      <div className="thumbContainer">
        {uniqueImageUrls &&
          uniqueImageUrls?.length > 0 &&
          uniqueImageUrls?.map((url, index) => {
            const fileNameSplit = url?.split("/");
            const fileName =
              fileNameSplit?.length > 0 && fileNameSplit?.slice(-1)?.pop();
            const fileInfo = getFileInfo(url);

            const renderRemoveIcon = () =>
              removeIcon && (
                <div
                  className="removeIcon"
                  onClick={() => deleteImageURL(url, index)}
                >
                  X
                </div>
              );

            return (
              <div className="imgBox" key={index}>
                {fileInfo?.isImage && (
                  <>
                    {renderRemoveIcon()}
                    <img
                      src={
                        fileInfo?.isPreviewUnsupported
                          ? commonImages?.noimage
                          : url
                      }
                      className="dropImg"
                      alt={fileName}
                    />
                  </>
                )}

                {fileInfo?.isDocument && (
                  <>
                    {renderRemoveIcon()}
                    <img
                      className="dropImg"
                      src={commonImages?.docIcon}
                      alt={fileName}
                      onClick={() => handleDownload(url)}
                    />
                  </>
                )}

                {fileInfo?.isPdf && (
                  <>
                    {renderRemoveIcon()}
                    <img
                      className="dropImg"
                      src={commonImages?.pdfIcon}
                      alt={fileName}
                      onClick={() => handleDownload(url)}
                    />
                  </>
                )}
              </div>
            );
          })}

        {isLoader && (
          <Stack className="loaderDropBox" spacing={2} direction="row">
            <CircularProgress color="success" />
          </Stack>
        )}
      </div>
    </div>
  );
};

export default File;
